import { SalesHeader as NavBar } from '@uds/bookends';
import { ReactRouterLink } from '@uds/react-router-adapter';
import { useLanguagesMap } from 'domain/selectors/page';
import { useExternalRoutes } from 'domain/selectors/common';

import { usePageContext } from '../../components/PageContext';

export default function SalesHeader(): JSX.Element {
  const { actions } = usePageContext();
  const languages = useLanguagesMap();
  const languageMap = languages ?? {};
  const externalRoutes = useExternalRoutes();
  return (
    <NavBar
      onLanguageChange={actions.handleLanguageChange}
      LinkComponent={ReactRouterLink}
      externalRoutes={externalRoutes}
      languageMap={languageMap}
    />
  );
}
